import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import ImageWrapper from 'components/helpers/ImageWrapper/ImageWrapper';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import classnames from 'classnames';
import { pushCarouselClickDataLayerObject } from 'lib/util/gtm-datalayer';

SwiperCore.use([Pagination, Navigation]);

type ProductImagesParams = {
  productImages: Sitecore.Override.ItemEx[];
};

const ProductImage = ({ productImages }: ProductImagesParams): JSX.Element => {
  const loopSwiper = true;

  const cardsToDisplay = 1;

  const cardClasses = classnames(
    'flex',
    'h-auto',
    'flex-col',
    { 'lg:flex-row': cardsToDisplay === 1 },
    'items-center'
  );

  const swiperControlsClasses = classnames(
    'm-auto',
    'my-4',
    'flex',
    'h-6',
    'w-max',
    'items-center',
    'lg:mb-0'
    // Applies hidden-class for swiper control buttons for md-size page and higher
    // if count of cards for displaying on swiper not less than count of cards in collection.
  );

  const cardColClass = classnames({
    'card-wrapper--1': cardsToDisplay === 1,
  });

  const singleImageRender = (item: Sitecore.Override.ItemEx) => {
    const nextImageField = {
      ...item.fields,

      value: {
        src: item.url,
        alt: item.name,
        height: '525',
        width: '395',
      },
    };
    return (
      <div className={classnames('product-image')}>
        <ImageWrapper key={item.id} field={nextImageField} />
      </div>
    );
  };

  const cardsMapped = productImages?.map((value) => {
    return (
      <SwiperSlide key={value.id} className={cardClasses}>
        {singleImageRender(value)}
      </SwiperSlide>
    );
  });

  let clickAction = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleRealIndexChange = async (swiper: any) => {
    // eslint-disable-next-line no-promise-executor-return
    await new Promise((r) => setTimeout(r, 200));
    pushCarouselClickDataLayerObject(
      swiper.realIndex,
      clickAction,
      'product image carousel',
      productImages
    );
    clickAction = '';
  };
  const handlePrev = () => {
    clickAction = 'carousel - left click';
  };
  const handleNext = () => {
    clickAction = 'carousel - right click';
  };

  const renderCardContainer = (list: {}) => {
    return (
      <Swiper
        loop={loopSwiper}
        loopedSlides={cardsToDisplay}
        slidesPerView={1}
        slidesPerGroup={1}
        breakpoints={{
          1024: {
            slidesPerView: cardsToDisplay,
            slidesPerGroup: cardsToDisplay,
          },
        }}
        spaceBetween={30}
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        }}
        pagination={{
          clickable: true,
          el: '.swiper-pagination',
          bulletElement: 'button',
        }}
        className={cardColClass}
        onRealIndexChange={handleRealIndexChange}
      >
        {list}
        <div slot="container-end" className={classnames('lg:mt-4')}>
          <div className={swiperControlsClasses}>
            <button type="button" className="swiper-button-prev" onClick={handlePrev}>
              prev
            </button>
            <div className="swiper-pagination" />
            <button type="button" className="swiper-button-next" onClick={handleNext}>
              next
            </button>
          </div>
        </div>
      </Swiper>
    );
  };
  const returnData = (): JSX.Element => {
    if (productImages?.length > 1) {
      return renderCardContainer(cardsMapped);
    }
    if (productImages?.[0]) {
      return singleImageRender(productImages[0]);
    }
    return <></>;
  };
  return <>{returnData()}</>;
};
export default ProductImage;
